export default "__VITE_ASSET__DCfUuVTW__"